import { render, staticRenderFns } from "./SpecialCharacterRemoverForm.vue?vue&type=template&id=8a932900&"
import script from "./SpecialCharacterRemoverForm.vue?vue&type=script&lang=js&"
export * from "./SpecialCharacterRemoverForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports